import {alpha} from "@mui/material/styles";

const overrideAutocompleteStyles = theme => ({
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& span.MuiAutocomplete-tag': {
          fontSize: '0.8125rem',
          width: 40,
          height: 21,
          textAlign: 'center',
          borderRadius: theme.shape.borderRadius,
          backgroundColor: alpha(theme.palette.grey[500], 0.16)
        }
      },
      paper: {
        boxShadow: theme.customShadows.dropdown
      },
      listbox: {
        padding: theme.spacing(0, 1)
      },
      option: {
        padding: theme.spacing(1),
        margin: theme.spacing(0.75, 0),
        borderRadius: theme.shape.borderRadius
      }
    }
  }
})

export default overrideAutocompleteStyles
